import React, { useState, useEffect } from "react";
import { getAccessTokenApi ,getRefreshTokenApi,getPublicIP} from "../../../api/auth";
import { getUsersActiveApi, Keyrock } from "../../../api/user";
import ListUsers from "../../../components/Admin/Users/ListUsers";
import { BrowserRouter as Router, Link, Route, Routes } from "react-router-dom";
import { message, Upload, Button,Checkbox,Divider ,notification,TreeSelect  ,Col, InputNumber, Row, Slider, Space ,Switch} from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { basePath, apiVersion } from "../../../api/config";
import Logo from "../../../assets/img/png/logo-white.png";
import {getContarError} from "../../../api/user";
import {get} from "../../../api/get";

import "./Instructions.scss";

export default function Instructions() {
  const [usersActive, setUsersActive] = useState([]); //Todos los usuarios
  const [usersInactive, setUsersInactive] = useState([]);
  const [reloadUsers, setReloadUsers] = useState(false);

  const token = getAccessTokenApi();

  function getpdf() {
    const url = `${basePath}/${apiVersion}/get-pdf`;
    var status;
    var urlFetch='';
    //console.log(url);
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getAccessTokenApi(),
      refreshToken: "Bearer " + getRefreshTokenApi(),
      functionname:'getExcel',
      ippublica:getPublicIP()
      },
    };
  
    return fetch(url, params)
      .then((response) => {
        status=response.status;
        urlFetch=response.url;
        urlFetch=urlFetch.replace(`${basePath}/${apiVersion}/`,'')
        return response.blob()})
      .then((blobby) => {
        if(status!==200){
          notification["error"]({
            message: `Error ${status} in function: ${urlFetch}`,
          });
          getContarError(urlFetch,`Error ${status} in function: ${urlFetch}`);
        }
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        let objectUrl = window.URL.createObjectURL(blobby);
  
        anchor.href = objectUrl;
        anchor.download = 'instructions.pdf';
        anchor.click();
  
        window.URL.revokeObjectURL(objectUrl);
      })
      .catch((err) => {
        return err.message;
      });
  }

  useEffect(() => {
    get(`users-active?active=${true}`,'users-active','').then((response) => {
      // getUsersActiveApi(token, true).then((response) => {
        //console.log(response);
        setUsersActive(response.users);
      });
    get(`users-active?active=${false}`,'users-active','').then((response) => {
    // getUsersActiveApi(token, false).then((response) => {
      setUsersInactive(response.users);
    });

    setReloadUsers(false);
  }, [token, reloadUsers]); //Solo se refresca si cambian estos

  return (
    <>
    <div className="instructions">
        <div className="instructions-up">
            <a href="/" className="instructions-up-pictureAndLogo-logo">
              <img src={Logo} alt="logo" />
            </a>
        </div>
        <div className="instructions-down">
            <Button className="boton"
            disabled={/* disable */false}
            style={{borderColor: "rgb(203,234,247)", 
            backgroundColor: "rgb(203,234,247)" ,
            color:'rgb(0,104,178)',
            fontFamily:'report',
            fontSize:'17px',
            marginTop:'10px'}}
            type="primary"
            onClick={ () => {
              getpdf()
              }}>
            Download instructions of usage
            <CloudDownloadOutlined style={{color:'rgb(0,104,178)'}}/>
          </Button>
          
        </div>
      </div>
      <div className="marg">
        <h2>Software development phases: </h2>
        <div className="fases">
          <div className="fases-num1">
              <h1>1. Optimizer</h1>
          </div>
          <div className="fases-sep">
          </div>
          <div className="fases-num1">
            <h1>2. Parametric Scan</h1>
          </div>
          <div className="fases-sep">
          </div>
          <div className="fases-num">
            <h1>3. Hubs IA</h1>
          </div>
          <div className="fases-sep">
          </div>
          <div className="fases-num1">
            <h1>4. BI </h1>
          </div>
          <div className="fases-sep">
          </div>
          <div className="fases-num1">
            <h1>5. Colaborate</h1>
          </div>
        </div>
        <h1 >We are currently in the third version of the software, in which we want to show the added functionalities in the simulation submission screen.  In this same screen you will be able to see the functionalities that you want to introduce in version 3 of the software, however when you select them you will see that they are still under development. Version 4 of the software will be accompanied by a new and improved user interface. </h1>
      </div>
    </>
  );
}
